import { createStyles } from '@mantine/styles';

var useStyles = createStyles(() => ({
  overlay: {}
}));

export default useStyles;
//# sourceMappingURL=ModalBaseOverlay.styles.js.map
